import React, { useEffect, memo } from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import Slide from "@mui/material/Slide";
import { openAlert } from "./types";
import { useAppDispatch, useAppSelector } from "../../AppUtils/Utils/appHooks";
import { closeAlertAction } from "../../Pages/CommonAppRedux/CommonAppSlice";
import { commonAppSelector } from "../../Pages/CommonAppRedux/selector";

const TransitionLeft = (props: any) => {
  return <Slide {...props} direction="left" timeout={250} />;
};

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
const CustomAlert = ({ openAlert, data }: openAlert) => {
  const { error, info, success } = useAppSelector(commonAppSelector);
  const [open, setOpen] = React.useState(false);
  const dispatch = useAppDispatch();
  // open alert function
  const openAlertFunction = () => {
    setOpen(openAlert);
  };
  // run effect when component mounts
  useEffect(() => {
    openAlertFunction();
  }, []);
  // close alert
  const handleClose = () => {
    setOpen(false);
    dispatch(closeAlertAction());
  };
  return (
    <>
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={open}
        TransitionComponent={TransitionLeft}
        autoHideDuration={2500}
        onClose={handleClose}
      >
        {error ? (
          <Alert
            severity="error"
            variant="filled"
            onClose={() => handleClose()}
          >
            {data}
          </Alert>
        ) : info ? (
          <Alert severity="info" variant="filled" onClose={() => handleClose()}>
            {data}
          </Alert>
        ) : (
          <Alert
            severity="success"
            variant="filled"
            onClose={() => handleClose()}
          >
            {data}
          </Alert>
        )}
      </Snackbar>
    </>
  );
};
export default memo(CustomAlert);
